import {
  registerNewUserMenu,
  updateUserMenu,
  userMetricsMenu,
} from './state';

const menu = {
  text: 'User',
  menu_width: 220,
  menu: [
    {
      text: 'Register New User',
      click: () => { registerNewUserMenu.value = true; },
    },
    {
      text: 'Update User',
      click: () => { updateUserMenu.value = true; },
    },
    {
      text: 'User Metrics',
      click: () => { userMetricsMenu.value = true; },
    },
  ],
};

export { menu };
